import Combobox from './combobox';
import { ready, fetchApiUrl } from './utilities';

let container;
ready(init);

async function init() {
  container = document.querySelector('.js-politician-table');

  const stockFilterElem = document.querySelector('#stock-filter');
  const insiderFilterElem = document.querySelector('#insider-filter');
  const companyFilterButtons = document.getElementsByName('company-filter');

  if (!stockFilterElem && !insiderFilterElem && companyFilterButtons.length === 0) {
    return;
  }

  // Stock filter - behaves like congress stock filter
  const selectedStock = new URLSearchParams(window.location.search).get('stock');
  new Combobox({
    valueKey: 'symbol',
    selected: selectedStock,
    root: stockFilterElem,
    search: async (text) => {
      const stocksReq = await fetchApiUrl('/api/v1/stocks?query=' + (text || ''));
      const stocks = await stocksReq.json();
      return stocks;
    },
    render: (stock) => {
      const div = document.createElement('div');
      div.textContent = `${stock.name} (${stock.symbol})`;
      return div;
    },
    update: (value) => {
      if (value) {
        window.location.href = `/insider-trades/${value.toLowerCase()}`;
      }
    }
  });

  // Insider filter - searches names and updates the index via JSON
  if (insiderFilterElem) {
    const selectedInsider = new URLSearchParams(window.location.search).get('insider');
    new Combobox({
      valueKey: 'name',
      selected: selectedInsider,
      root: insiderFilterElem,
      search: async (text) => {
        const resp = await fetchApiUrl('/api/v1/insiders?query=' + encodeURIComponent(text || ''));
        const insiders = await resp.json();
        return insiders;
      },
      render: (insider) => {
        const div = document.createElement('div');
        div.textContent = insider.name;
        return div;
      },
      update: (value) => {
        updatePage('insider', value);
      }
    });
  }

  // Company size filter (Top vs All)
  // Default is Top Companies when no param present
  let selectedCompany = new URLSearchParams(window.location.search).get('company') || 'top';
  companyFilterButtons.forEach((button) => {
    if (button.value === selectedCompany) {
      button.checked = true;
    }
    button.addEventListener('click', () => {
      selectedCompany = button.value;
      // When 'top' is selected, remove param; when 'all', set ?company=all
      updatePage('company', selectedCompany === 'top' ? null : 'all');
    });
  });
}

async function updatePage(param, newValue) {
  const url = new URL(window.location.href, window.location);
  if (newValue) {
    url.searchParams.set(param, newValue);
  } else {
    url.searchParams.delete(param);
  }
  window.history.pushState({}, '', url);

  url.searchParams.append('format', 'json');
  const response = await fetch(url);
  const json = await response.json();

  if (container) {
    container.innerHTML = json.html;
    container.dataset.path = url; // used for infinite scrolling
    container.dataset.nextPage = 2;
  }
}

window.addEventListener('popstate', function () {
  if (window.location.pathname === '/insider-trades') {
    window.location.reload();
  }
});


